import React, { Component } from 'react'
import { Link, BrowserRouter as Router, Route } from 'react-router-dom'
import Navbar from './Navbar'
import Gallery from './Gallery'
import Quiz from './Quiz'
import OMnie from './OMnie'
import Kontakt from './Kontakt'

// <div className='titlefont' style={{fontSize: '40px', lineHeight: '60px', marginTop: '-10px'}}>Jadwiga Sikorska</div>
const Title = props => <div style={{color: 'white', textAlign: 'center', padding: '20px 0'}}>
  <div className='titlefont' style={{fontSize: '100px', lineHeight: '1em', display: 'inline', fontVariant: 'italic'}}>Arteco</div>
</div>

const Menu = props => <div className='bodyfont' style={{color: 'white', textAlign: 'center', listDecorationStyle: 'none', fontWeight: 'bold', fontVariant: 'small-caps', fontSize: '24px', lineHeight: '1.5em'}}>
  <div className='hero is-fullheight'>
    <div className='hero-body'>
      <div className="container has-text-centered">
        <Title />
        <nav className='level'>
          <Link to='/omnie' className='level-item has-text-centered'>
            <div>
              <p className='heading'>Czym się zajmuję?</p>
              <p className='title titlefont'>O nas</p>
            </div>
          </Link>
          <Link to='/galeria' className='level-item has-text-centered'>
            <div>
              <p className='heading'>Galeria prac</p>
              <p className='title titlefont'>Zdjęcia</p>
            </div>
          </Link>
          <Link to='/quizy' className='level-item has-text-centered'>
            <div>
              <p className='heading'>interaktywna gra</p>
              <p className='title titlefont'>Quiz</p>
            </div>
          </Link>
          <Link to='/kontakt' className='level-item has-text-centered'>
            <div>
              <p className='heading'>Napisz do mnie</p>
              <p className='title titlefont'>Kontakt</p>
            </div>
          </Link>
        </nav>
      </div>
    </div>
    <div class="hero-foot">
    <nav class="tabs is-boxed is-fullwidth">
      <div class="container">
        <ul>
          <li><a style={{color: 'white'}} target='_blank' href='https://www.facebook.com/pg/Arteco-Stargard-423015501612649/posts/?ref=page_internal'><i className='fab fa-facebook-f'></i></a></li>
          <li><i className='fab fa-deviantart'></i></li>
          <li><a style={{color: 'white'}} href='mailto:jadwiga.sikorska3@gmail.com'><i className='fal fa-at'></i></a></li>
        </ul>
      </div>
    </nav>
  </div>
  </div>

</div>

class App extends Component {
  render () {
    return <Router><div id='grid'>
      <div id='bg' />
      <Navbar />
      <Route component={Menu} path='/' exact />
      <Route component={OMnie} path='/omnie' exact />
      <Route component={Gallery} path='/galeria' exact />
      <Route component={Quiz} path='/quizy' exact />
      <Route component={Kontakt} path='/kontakt' exact />
    </div></Router>
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js